















import Vue from 'vue';

export default Vue.extend({
  name: 'ConfirmCancel',
  props: {
    prevData: {
      required: true,
      type: Object as ()=> any,
    },
  },
  methods: {
    handleConfirm(): void {
      this.$parent.$emit('tpCloseModal');
      if (this.prevData.isFromTaskManager) {
        this.$parent.$emit('reopenTaskManager');
      }
    },
  },
});
